import { render, staticRenderFns } from "./childInformation.vue?vue&type=template&id=2b8835e0&scoped=true&"
import script from "./childInformation.vue?vue&type=script&lang=js&"
export * from "./childInformation.vue?vue&type=script&lang=js&"
import style0 from "./childInformation.vue?vue&type=style&index=0&id=2b8835e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8835e0",
  null
  
)

export default component.exports